import React, { Component } from "react";
import { Link } from "react-router-dom";
import { MenuItems } from "./menuitems";
import "./navbarstyles.css";
import supabase from '../supabaseClient';

class Navbar extends Component {
  state = {
    clicked: false,
    user: null,
  };

  async componentDidMount() {
    const { data: { user } } = await supabase.auth.getUser();
    this.setState({ user });
  }

  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };

  handleLogout = async () => {
    await supabase.auth.signOut();
    this.setState({ user: null });
  };

  render() {
    return (
      <nav className="NavbarItems obj-width">
        <h1>
          <Link className="navbar-logo" to={"/"}>
            ARCITY
          </Link>
        </h1>
        <div className="menu-icons" onClick={this.handleClick}>
          <i
            className={this.state.clicked ? "fas fa-times" : "fas fa-bars"}
          ></i>
        </div>

        <ul className={this.state.clicked ? "nav-menu active" : "nav-menu"}>
          {MenuItems.map((item, index) => (
            <li key={index}>
              <Link className={item.cName} to={item.url}>
                <i className={item.icon}></i>
                {item.title}
              </Link>
            </li>
          ))}
          {/* Conditionally render Sign Up button or user info */}
          {this.state.user ? (
            <li>
              <span className="user-name">
                Hello, {this.state.user.email}
              </span>
              <button onClick={this.handleLogout} className="logout-btn">
                Logout
              </button>
            </li>
          ) : (
            <li>
              <Link to="/signup" className="signup-btn">
                Sign Up
              </Link>
            </li>
          )}
        </ul>
      </nav>
    );
  }
}

export default Navbar;
